<template>
  <div class="Words" :class="{ 'share': on_share }">  
    <Title indice="words"/>  
    <div ref="area" class="Words__txt">
      <textarea ref="textarea" name="story" @focus="onFocus()" @blur="onBlur()" placeholder="" maxlength="150"/>
      <div class="Words__holder" v-if="!is_focus">Tap to start typing</div>
    </div>
    <Description ref="description" indice="words"/>
    <div ref="block" class="Bottom">
      <ShareButton v-if="written"/>
    </div>
    <ShareComp indice="words"/>
    <ExempleButton indice="read" v-if="!use_exemple"/>
    <ReadComp v-if="use_exemple"/>
  </div> 
</template>

<script>

import gsap from "gsap"
import BackButton from "./assets/BackButton.vue"
import Title from "./assets/Title.vue"
import Description from "./assets/Description.vue"
import ShareButton from "./assets/ShareButton.vue"
import ShareComp from "./assets/ShareComp.vue"
import ExempleButton from "./assets/ExempleButton.vue"
import ReadComp from "./assets/ReadComp.vue"

export default {

  name: 'Words',
  components: { BackButton, Title, Description, ShareButton, ShareComp, ExempleButton, ReadComp },
  data: ()=>({
    step: '',
    on_share: false,
    written: false,
    use_exemple: false,
    is_focus: false
  }),
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.on_share = this.$root.route.to.params.step == 'share' ? true : false
      }
    }
  },
  mounted() {
    
    this.$nextTick(()=>{

      gsap.from(this.$refs.area, {
        duration: .35, 
          opacity: 0,
          ease: 'none', 
          delay: .5, 
      })


      gsap.from([ this.$refs.description.$el ], {
        duration: .5, 
          y: '+=400%', 
          ease: 'cubic.out', 
          stagger: .2,
          delay: .75, 
      })
    })


  },
  methods:{
    onFocus() {
      this.is_focus = true
      // gsap.set(this.$refs.block, { display: 'none' })
    },
    onBlur() {
      this.written = true

      // window.alert('blur')
      // gsap.set(this.$refs.block, { display: 'flex' })
    }, 
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Words
  position absolute
  top 0
  left 0
  color white
  width 100%
  height 100%
  display flex 
  flex-direction column
  justify-content space-between
  align-items center
  transition opacity .35s
  opacity 1

  &.share
    opacity .15

  &__txt
    background #25253f
    font-size .81em
    border-radius 16px
    color white
    width 81%
    height 26%
    margin 12% 4vw 2%
    padding-top 4%
    font-size 1.06em
    font-family SpaceGrotesk
    text-align center
    border none 
    position relative

  & textarea
    background transparent
    font-size .81em
   
    color white
    width 100%
    height 100%
 
    font-size 1.06em
    font-family SpaceGrotesk
    text-align center
    border none

  & ::placeholder 
    color rgba(white, .75)
    font-size .81em

  &__holder 
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    font-size .81em
    pointer-event none

</style>


